<template lang="pug">
	Popup(v-if="popupVisible", :popupVisible="popupVisible", :title="$tCaption('New') + ' ' + campaignType", :width="420")
		.new-campaign-dialog.flex-col.space-large
			.flex-col.field
				.font-tiny.upper.grey {{$tCaption('Name')}}
				DxTextBox(slot="editor", :value.sync="campaign.Name", :disabled="isLoading")
					dx-validator
						dx-required-rule(:message="$tCaption('Name is required')")
			.flex-col.field
				.font-tiny.upper.grey {{$tCaption('Advertiser')}}
				Dropdown.full-width(ref="advertiser",
					slot="editor",
					v-model="campaign.Advertiser.Oid", 
					:preloadedObjects="[campaign.Advertiser]",
					:disabled="$auth.isAdvertiser() || isLoading"
					:multiple="false", 
					:getData="(a,b,opts) => $Data.getExternalCompanies(a,b,{ ...(opts || {}), byType: 0 })", 
					:getItems="r => r.Results",
					:columns="[{ dataField: 'Name', caption: () => $tCaption('Name'), sortIndex: 0, sortOrder: 'asc' }]",
					:searchVisible="true",
					:showColumnHeaders="false",
					:filtersVisible="false",
					valueExpr="Oid",
					displayExpr="Name",
					@select-data="v => campaign.Advertiser = v || { Oid: null }")
			.flex-col.field
				.font-tiny.upper.grey {{$tCaption('Agency')}}
				Dropdown(ref="agency",
					slot="editor",
					v-model="campaign.Agency.Oid", 
					:preloadedObjects="[campaign.Agency]",
					:disabled="$auth.isAgency() || isLoading"
					:multiple="false", 
					:getData="(a,b,opts) => $Data.getExternalCompanies(a,b,{ ...(opts || {}), byType: 2 })", 
					:getItems="r => r.Results",
					:columns="[{ dataField: 'Name', caption: () => $tCaption('Name') }]",
					:searchVisible="true",
					:showColumnHeaders="false",
					:filtersVisible="false",
					valueExpr="Oid",
					displayExpr="Name",
					@select-data="v => campaign.Agency = v || { Oid: null }")
			.flex-col.field
				.font-tiny.upper.grey {{$tCaption('Start date')}}
				DxDateBox(slot="editor", :value.sync="campaign.StartDate", :disabled="isLoading")
					dx-validator
						dx-required-rule(:message="$tCaption('Start date is required')")
			.flex-col.field
				.font-tiny.upper.grey {{$tCaption('End date')}}
				DxDateBox(slot="editor", :value.sync="campaign.EndDate", :disabled="isLoading")
					dx-validator
						dx-required-rule(:message="$tCaption('End date is required')")
		template(slot="actions-right")
			DxButton(:text="$tCaption('Cancel', '@actions')", @click="popupVisible = false", :disabled="isLoading")
			DxButton(:text="$tCaption('Create', '@actions')", type="success", @click="createCampaign", :disabled="isLoading")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import Loader from 'app-core/Loader.vue';
	import Dropdown from 'app-core/Dropdown.vue';	
	import { CAMPAIGN_TYPES } from 'app-core/constants';	
	import Popup from 'app-core/Popup.vue';
	import DxValidationGroup from 'devextreme-vue/validation-group';
	import DxValidator, { DxRequiredRule } from 'devextreme-vue/validator';

	export default {
		translationCategory: 'campaign.Detail',
		name: 'campaign-overview',
		components: {
			DxButton, DxTextBox, Loader, DxDateBox, Dropdown, Popup,
			DxValidationGroup,DxValidator, DxRequiredRule
		},
		props: ['type'],
		data() {
			return {
				campaignTypes: CAMPAIGN_TYPES.toLocale('name', this),
				popupVisible: false,
				campaign: {
					Advertiser: this.$auth.isAdvertiser() ? this.$auth.company() : { Oid: null },
					Agency: this.$auth.isAgency() ? this.$auth.company() : { Oid: null },
					StartDate: null,
					EndDate: null,
					Name: null
				},
				isLoading: false
			};
		},
		computed: {
			campaignType() {
				return this.campaignTypes[this.type || 0]?.name;
			},
		},
		mounted() {
			if (__DEBUG__)
				window.newCampaignDialog = this;
		},
		methods: {
			show() {
				this.popupVisible = false;
				_.assign(this.campaign, {
					Advertiser: this.$auth.isAdvertiser() ? this.$auth.company() : { Oid: null },
					Agency: this.$auth.isAgency() ? this.$auth.company() : { Oid: null },
					StartDate: new Date(),
					EndDate: new Date(),
					Name: null,
					CampaignType: this.type
				});
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.popupVisible = true;
				});
			},
			createCampaign(e) {
				if (!e.validationGroup.validate().isValid) {
					return;
				}

				this.isLoading = true;
				this.$Data.postExternalApi('Campaign/CreateUpdateCampaign', {
					...this.campaign,
					StartDate: this.$Data.dateToString(this.campaign.StartDate),
					EndDate: this.$Data.dateToString(this.campaign.EndDate),
				}).then(r => {
					if (r?.Data?.Oid) {
						this.$router.push({ name: `${this.type === 1 ? 'campaign' : 'proposal'}-detail`, params: { wizard: this.type == 0, id: r?.Data?.Oid } });
					}
				})
				.finally(() => this.isLoading = false);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.new-campaign-dialog {
	}
</style>
 